module.exports = "<form class=\"form\" [formGroup]=\"editCreditCardForm\" novalidate (ngSubmit)=\"onSubmit()\">\r\n  <div class=\"col-md-10\" formGroupName=\"editCreditCard\">\r\n    <app-credit-card [creditCardGroup]=\"editCreditCardForm.controls.editCreditCard\"></app-credit-card>\r\n  </div>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/edit-credit-card/edit-credit-card.component.html
// module id = ../../../../../src/app/component/edit-credit-card/edit-credit-card.component.html
// module chunks = main